import React, { useState, useEffect } from 'react'
import { useGeoState, useGeoFetch } from '../../../../components/GeoProvider'
import { useAuthState } from '../../../../components/AuthProvider'

import Spinner from '../../../../components/Loader/Spinner'
import FluDetailedView from './FluDetailedView'
const FluDetailedViewComponent = ({
  statesData,
  hash,
  stateJson,
  cbsaJson,
  zip3Json }) => {
    const {
        dataStartDate,
        dataEndDate,       
      } = useGeoState()
      const entity = 'flu'
    const { user } = useAuthState()
   debugger
    const [getmetrosCombinedData, setmetrosCombinedData] = useState()
    const [getZip3sData, setZip3sData] = useState()
    const { data: metrosCombinedData, error: metrosCombinedDataError } =
      useGeoFetch(dataStartDate, dataEndDate, entity, 'msa?seasons=all')

  useEffect(() => {
    if (metrosCombinedData !== null && metrosCombinedData !== undefined) {
      if (metrosCombinedData.response_code === 200) {
        setmetrosCombinedData(metrosCombinedData.response_data)
      } else {
        // setErrorCode(metrosCombinedData.response_code)
        // setErrorMessage(metrosCombinedData.response_message)
        // setErrorSubject(metrosCombinedData.response_subject)
        // seterrorOccured(true)
      }
    }
    //setMetros(cbsaData)
  }, [metrosCombinedData])
  
      const { data: zip3sCombinedData, error: zip3sCombinedDataError } =
    useGeoFetch(dataStartDate, dataEndDate, entity, 'zip3?seasons=all')

  useEffect(() => {
    if (zip3sCombinedData !== null && zip3sCombinedData !== undefined) {      
      if (zip3sCombinedData.response_code === 200) {
        setZip3sData(zip3sCombinedData.response_data)
      } else {
        
      }
    }
  }, [zip3sCombinedData])

    return (
        <>      
        {getmetrosCombinedData !== undefined && getZip3sData !== undefined ? (
        <FluDetailedView
        cbsaData={getmetrosCombinedData}
        statesData={statesData}
        zip3Data={getZip3sData}
        hash={hash}
        stateJson={stateJson}
        cbsaJson={cbsaJson}
        zip3Json={zip3Json}
      />
        ) : (
         <Spinner/>
        )}
      </>
    )
}

export default FluDetailedViewComponent